import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type CancelImportMutationVariables = Types.Exact<{
  input: Types.CancelImportInput;
}>;


export type CancelImportMutation = { __typename?: 'Mutation', cancelImport?: boolean | null };


export const CancelImport = /*#__PURE__*/ gql`
    mutation CancelImport($input: CancelImportInput!) {
  cancelImport(input: $input)
}
    ` as unknown as DocumentNode<CancelImportMutation, CancelImportMutationVariables>;

          

          export const useCancelImportMutation = (options?:MutationHookOptions<CancelImportMutation, CancelImportMutationVariables>) => useMutation(CancelImport, options);
          

          export type CancelImportMutationOptions = MutationHookOptions<CancelImportMutation, CancelImportMutationVariables>;

          

          export type CancelImportMutationResult = ReturnType<typeof useCancelImportMutation>[1];

          
